import { Badge } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import './style.scss';
import { HeaderActions } from './actions';

export function SmartQuoteHeader() {
  return (
    <header className="flex-x sticky-top smart-quote-header">
      <div className="flex-x flex-grow-1 gap-2 py-2 px-20px  smart-quote-heading">
        <FormattedMessage id="smartQuote.workspace.pageTitle" tagName="h5" />
        <Badge color="info" size="sm" isPill purpose="outline">
          <FormattedMessage id="smartQuote.workspace.pageTitle.previewBadge" />
        </Badge>
      </div>
      <HeaderActions />
    </header>
  );
}
